import dashboard from './dashboardReducer';

export default {
  dashboard
};
